import * as _ from 'lodash';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { PeerToPeerManageService } from '../../services/peer-to-peer-manage/peer-to-peer-manage.service';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { loadP2PCampaignList } from '../../features/p2p.actions';
import { selectP2PCampaignsList } from '../../features/p2p.selectors';
import { PeerToPeerCardComponent } from '../peer-to-peer-card/peer-to-peer-card.component';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone:true,
  selector: 'app-peer-to-peer-list',
  templateUrl: './peer-to-peer-list.component.html',
  styleUrls: ['./peer-to-peer-list.component.scss'],
  imports:[PeerToPeerCardComponent,FormsModule,ReactiveFormsModule,CommonModule]
  
})
export class PeerToPeerListComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public newP2PCampaigns$: any = this.store.pipe(
    select(selectP2PCampaignsList)
  );

  public P2PCampaigns = []
  public filteredP2PCampaigns = []
  public search: UntypedFormControl = new UntypedFormControl('', []);

  constructor(
    public store: Store,
    public sharedService: SharedService,
    public peerToPeerManageService:PeerToPeerManageService
  ) { }

  ngOnInit() {
    this.store.dispatch({
      type: loadP2PCampaignList.type,
      payload: this.sharedService.token
    });
    
    this.newP2PCampaigns$.pipe(
      filter((list:any)=> list.length > 0),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((P2PCampaigns)=>{
      this.P2PCampaigns = [...P2PCampaigns];
      this.filteredP2PCampaigns = [...P2PCampaigns];
    });

    this.search.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(searchQuery => {
      this.filteredP2PCampaigns = _.filter(this.P2PCampaigns, (p2p: any) => {
        return _.includes(p2p.name.toLowerCase(), searchQuery.toLowerCase())
      });
    }); 
  }

  trackById(index: number, item: any): number {
    return item.id; 
  }

  resetSearch() {
    this.search.setValue('');
  }
}
